export default __webpack_public_path__ + "static/media/dyes.ea5f6039.png";